import { CONSTANT } from '@/constant/index'
import ChatModel from '@/model/chatModel'
import SocketControl from './socketControl'
import * as Utils from '@/assets/script/utils'
import { getSearchList, getQuestionById, submitFeedback } from '@/database/index'

// 可撤回时间（minute）
const WITHDRAW_TIME = 2

class ChatControl {
  constructor() {
    this.chatModel = new ChatModel()
    // 人工客服连接状态
    this.connected = false
    // setTimeout(() => {
    //   this.readReceiveInfo()
    // }, 500)
    this.visibilityState = true

    document.addEventListener('visibilitychange', () => {
      this.readReceiveInfo()
    })


    this.getSystemInfo()
  }

  /**
   * 输入框信息添加到聊天
   * @param {String} content 信息内容
   */
  async addInfoBySend(content) {
    console.log('🔍 [ChatControl] 准备发送消息:', content)
    const option = {
      type: 'SEND',
      title: content
    }
    if (this.connected) {
      console.log('🔍 [ChatControl] 已连接客服，发送人工客服消息')
      option.type = 'SEND, ARTIFICIAL'
      option.unread = true
    } else {
      console.log('🔍 [ChatControl] 未连接客服，使用自动回复')
    }
    const info = await this.chatModel.add(option)
    if (this.connected) {
      console.log('🔍 [ChatControl] 调用socketControl.send()')
      this.socketControl.send(content, info.id)
      return
    }
    // 自动回复答复
    const answers = CONSTANT.ANSWER_BY_KEYWORD.filter(item => {
      const list = item.keyword.filter(word => content.search(word) > -1)
      return list.length > 0
    })

    if (answers.length > 0) {
      console.log('🔍 [ChatControl] 找到关键词匹配的自动回复')
      this.addInfoByReceive(
        {
          title: answers[0].answer
        },
        true
      )
    } else {
      console.log('🔍 [ChatControl] 未找到关键词匹配，查询相关问题')
      this.getInfoByQuestion(content)
    }
  }

  /**
   * 根据输入内容获取接收信息
   * @param {String} content 消息信息
   */
  async getInfoByQuestion(content) {
    if (this.connected) {
      this.socketControl.send(content)
      return
    }

    if (this.isLoading) return

    const params = {
      title: content,
      questionNum: 6
    }
    const result = await getSearchList(params)
    const list = result.questionList

    if (result.count > 0) {
      const suggestions = list.slice(1, params.questionNum).map(item => ({
        id: item.id,
        title: item.title
      }))
      this.chatModel.add({
        type: 'RECEIVE, ARTICLE',
        title: list[0].title,
        content: list[0].contentStr,
        suggestions
      })
    } else {
      this.addInfoByReceive(
        {
          title: CONSTANT.ANSWER_NO_REPLY
        },
        true
      )
    }
  }

  /**
   * 添加系统提示信息
   * @param {String} content 消息信息
   */
  addInfoBySystem(content) {
    this.chatModel.add({
      type: 'SYSTEM',
      title: content
    })
  }

  /**
   * 添加自动回复信息
   * @param {Object} config Info config
   * @param {Boolean} isInput 是否自动显示输入中
   */
  async addInfoByReceive(
    { id, title, type = 'RECEIVE', unread },
    isInput = false
  ) {
    if (this.inputingId) {
      this.removeInfoOfInput()
    }
    if (isInput) {
      type = 'RECEIVE, AUTO_REPLY'
    }
    await this.chatModel.add({ id, title, type, unread })
  }

  /**
   * 添加输入中提示
   */
  async addInfoOfInput() {
    if (this.inputingId) return
    const info = await this.chatModel.add({
      type: 'RECEIVE, INPUTING',
      title: '客服正在输入中...'
    })
    this.inputingId = info.id
  }

  /**
   * 删除输入中
   */
  removeInfoOfInput() {
    if (this.inputingId) {
      this.chatModel.remove(this.inputingId)
      this.inputingId = undefined
    }
  }

  /**
   * 添加文章类型消息
   * @param {Object} obj 消息Info
   */
  addInfoByArticle(obj) {
    this.chatModel.add({
      type: 'SEND',
      title: obj.title
    })
    const data = {
      type: 'RECEIVE, ARTICLE',
      title: obj.title,
      content: obj.contentStr,
      isFold: obj.contentStr.length > window.innerWidth * 0.232
    }
    if (obj.suggestions) {
      data.suggestions = obj.suggestions.map(item => ({
        id: item.id,
        title: item.title
      }))
    }
    this.chatModel.add(data)
  }

  /**
   * 添加音频信息
   * @param {String} content 音频信息
   */
  async addInfoByAudio(content) {
    const option = {
      title: content
    }
    const types = ['SEND', 'AUDIO']
    if (this.connected) {
      types.push('ARTIFICIAL')
      option.unread = true
    }
    option.type = types.join(',')

    const info = await this.chatModel.add(option)
    if (this.connected) {
      this.socketControl.send(content, info.id)
    } else {
      this.addInfoByReceive(
        {
          title: CONSTANT.ANSWER_NO_REPLY
        },
        true
      )
    }
  }

  /**
   * 添加文章类型消息很具ID查询
   * @param {Array} list 喜欢按钮
   * @param {Object} obj 消息Info
   */
  async addInfoArticleById(list, obj) {
    const result = await getQuestionById({
      id: obj.id
    })
    obj.suggestions = list.filter(item => item.id !== obj.id)
    const instance = Object.assign(obj, result.question)
    this.addInfoByArticle(instance)
  }

  /**
   * 文章底部按钮事件
   * @param {Array} item 喜欢按钮列表
   * @param {Object} child 当前按钮对象
   */
  setInfoStatusByArticle(item, child) {
    const list = item.assess.filter(l => l.checked)
    if (list.length > 0) return
    child.checked = !child.checked

    if (child.key === 'like') {
      this.addInfoBySend(child.name)
    } else {
      if (this.connected) return
      if (this.isLoading) return
      this.addInfoBySystem(CONSTANT.USELESS_TIP)
      this.initWebSocket()
    }
  }

  /**
   * 添加不在时间段提示
   * @param {Boolean} flag 是否显示夜间提示
   */
  addInfoNotTime(msg) {
    this.chatModel.add({
      type: 'RECEIVE, AUTO_REPLY',
      title: msg ? msg : CONSTANT.NOT_TIME_TIP
    })
  }

  /**
   * 是否显示撤回按钮
   * @param {Object} info
   */
  showWithdraw(info) {
    if (Utils.getSystem.isIOS) {
      info.time = info.time.replace(/\-/g, '/')
    }
    const isType = Utils.checkType('SEND & ARTIFICIAL', info.type),
      infoTimeStamp = Date.parse(info.time),
      nowTimeStamp = Date.parse(new Date())
    const intervaTime = (nowTimeStamp - infoTimeStamp) / 1000 / 60
    const isTime = intervaTime <= WITHDRAW_TIME
    return this.connected && isType && isTime
  }

  /**
   * 撤回信息
   * @param {Object} info
   */
  async withdrawInfo(info) {
    await this.socketControl.withdraw(info)
    this.chatModel.remove(info.id)
    this.addInfoBySystem(CONSTANT.WITHDRAW_SUCCESS)
  }

  /**
   * 消息设为已读
   */
  readReceiveInfo() {
    if (!this.connected) return
    if (document.visibilityState === 'visible') {
      this.visibilityState = true
      const infos = this.chatModel.getInfosByReceive()
      const ids = infos.map(info => info.id).join(',')
      this.socketControl.read(ids)
    } else {
      this.visibilityState = false
    }
  }

  /**
   * 音频消息设为已读
   */
  readReceiveAudio(id) {
    this.socketControl.read(id)
  }

  /**
   * 初始化人工客服
   */
  async initWebSocket() {
    console.log('🔍 [ChatControl] 开始初始化WebSocket')
    if (this.connected) {
      console.log('⚠️ [ChatControl] 已经连接，跳过初始化')
      return
    }
    console.log('🔍 [ChatControl] 创建SocketControl实例')
    this.socketControl = new SocketControl(this)
    console.log('🔍 [ChatControl] 调用SocketControl.init()')
    await this.socketControl.init()
    this.connected = !this.socketControl.disconnected
    console.log('🔍 [ChatControl] WebSocket初始化完成，连接状态:', this.connected)
  }

  /**
   * 重新连接
   */
  reconnectSocket() {
    console.log('🔄 [ChatControl] 开始重新连接')
    this.userInfo.connectType = 'manually'
    this.initWebSocket()
  }

  /**
   * 设置用户信息
   * @param {Object} data 用户信息
   */
  setUserInfo(data) {
    console.log('🔍 [ChatControl] 设置用户信息:', data)
    const test = {
      token: Utils.getGuid(),
      name: '客户' + Math.floor(Math.random() * 10000 + 1),
      avatar: '/static/images/water-user02.png'
    }
    const systemInfo = this.getSystemInfo()
    this.userInfo = {
      token: data.openId || test.token,
      name: data.nickname || test.name,
      avatar: data.avatarurl || test.avatar,
      ...systemInfo
    }
    console.log('🔍 [ChatControl] 用户信息设置完成:', this.userInfo)
  }

  /**
   * 获取设备信息
   */
  getSystemInfo() {
    let system, platform
    if (Utils.getSystem.isIOS) {
      system = 'iPhone'
    } else if (Utils.getSystem.isAndroid) {
      system = 'Android'
    } else {
      system = 'PC'
    }
    const info = navigator.userAgent
    if (info.indexOf('Alipay') > -1) {
      platform = '支付宝'
    } else if (info.indexOf('WeChat') > -1) {
      platform = '微信'
    } else {
      platform = '浏览器'
    }
    return { system, platform }
  }

  /**
   * 提交反馈信息
   * @param {Object} feedbackData 反馈数据
   */
  async submitFeedback(feedbackData) {
    console.log('📤 [ChatControl] 提交反馈信息:', feedbackData)

    try {
      const result = await submitFeedback(feedbackData)
      console.log('✅ [ChatControl] 反馈提交成功:', result)

      // 可选：发送确认消息给客服
      if (this.connected && this.socketControl) {
        this.socketControl.send('用户已确认信息')
      }

      return result
    } catch (error) {
      console.error('❌ [ChatControl] 反馈提交失败:', error)
      throw error
    }
  }
}

export default ChatControl



// WEBPACK FOOTER //
// ./src/controller/modules/chatControl.js